import { Component, Inject, Input, OnInit, inject, DestroyRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormUtilService } from 'src/app/services/util/form-util.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { Constants } from 'src/app/models/constants';
import { ComponentService } from 'src/app/services/api/component.service';
import { ToastrService } from 'ngx-toastr';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastrErrorService } from 'src/app/services/util/toastr-error.service';
import { translate } from '@jsverse/transloco';

@Component({
    selector: 'app-add-capability-dialog',
    templateUrl: './add-capability-dialog.component.html',
    styleUrls: ['./add-capability-dialog.component.scss'],
    standalone: false
})
export class AddCapabilityDialogComponent  implements OnInit {
private destroyRef = inject(DestroyRef);

  Constants = Constants;
  addCapabilityForm: FormGroup;
  statusOptions: any;
  typeOptions: any;
  encryptionKeys: any = {
    installationSpecification: false,
    secretSpec: false,
    installParam: false
  };
  components: any = [];
  selectedCapability: any;
  showCopyIcon: any = {
    installationSpecification: true,
    secretSpec: true,
    installParameterMapping: true
  };
  showEdit = false;
  isLoading = true;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any,
  public matdialogRef: MatDialogRef<AddCapabilityDialogComponent>, private formBuilder: FormBuilder,
  public sidenavService: SidenavService, private componentService: ComponentService, private toastrService: CustomToastrService,
  private toastrErrorService: ToastrErrorService) {
    
  }

  ngOnInit(): void {
    this.statusOptions = [
      {value: 'Dev' , selected: false},
      {value: 'Test' , selected: false},
      {value: 'Published' , selected: false},
      {value: 'Sunset' , selected: false},
      {value: 'Deprecated' , selected: false},
      {value: 'Comingsoon' , selected: false}
    ];
    this.typeOptions = [
      {value: 'mandatory' , selected: false},
      {value: 'optional' , selected: false}
    ];
    this.getComponents();
  }

  getComponents(): void {
    this.componentService.getComponents()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        this.components = data;
        this.createForm();
      },
      (error) => {
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  capabilitySelectionChange(event): void {
    this.selectedCapability = this.components.find(item => item.name === event);
  }

  getDeployment(): any {
    if (!FormUtilService.validateForm(this.addCapabilityForm)) {
      return;
    }
    return this.addCapabilityForm.getRawValue();
  }

  createDeployment(): void {
    if (!this.getDeployment()) {
      return;
    }
    const data = this.getDeployment();
    if (!this.encryptionKeys.installParameterMapping) {
      data.installParameterMapping = btoa(data.installParameterMapping);
    }
    data.displayName = this.selectedCapability.displayName;
    data.capabilityDetails = this.components.find(item => item.name === data.capability);
    this.matdialogRef.close(data);
  }

  createForm(): void {
    const formConfig: any = {
      capability: [undefined, [Validators.required]],
      version: [undefined, [Validators.required]],
      type: [undefined, [Validators.required]],
      installParameterMapping: ['', [Validators.required]]
    };
    this.addCapabilityForm = this.formBuilder.group(formConfig);
    if (this.data?.capability) {
      this.showEdit = true;
      this.addCapabilityForm.get('capability').setValue(this.data?.capability);
      this.addCapabilityForm.get('version').setValue(this.data?.version);
      this.addCapabilityForm.get('type').setValue(this.data?.type);
      this.addCapabilityForm.get('installParameterMapping').setValue(atob(this.data?.installParameterMapping));
      this.selectedCapability = this.data?.capabilityDetails;
      if (!this.data?.capabilityDetails) {
        this.addCapabilityForm.get('installParameterMapping').setValue(this.data?.installParameterMapping);
        this.selectedCapability = this.components.find(item => item.name === this.data.capability);
      }
    }
    this.isLoading = false;
  }

  encryptData(event, key): void {
    this.encryptionKeys[key] = event.checked;
    if (key === 'installParameterMapping') {
      if (event.checked) {
        this.addCapabilityForm.get('installParameterMapping').setValue(btoa(this.addCapabilityForm.get('installParameterMapping').value));
      } else {
        this.addCapabilityForm.get('installParameterMapping').setValue(atob(this.addCapabilityForm.get('installParameterMapping').value));
      }
    } else {
      if (event.checked) {
        this.selectedCapability[key] = key === 'installationSpecification' ?
          btoa(JSON.stringify(this.selectedCapability[key])) : btoa(this.selectedCapability[key]);
      } else {
        this.selectedCapability[key] = key === 'installationSpecification' ?
          JSON.parse(atob(this.selectedCapability[key])) : atob(this.selectedCapability[key]);
      }
    }
  }

  stringifyData(data): any  {
    return JSON.stringify(data);
  }

  checkType(data): any {
    return typeof(data);
  }

  changeIcon(key): void {
    this.showCopyIcon[key] = false;
    setTimeout(() => {
      this.showCopyIcon[key] = true;
    }, 3000);
  }

}
